import { defineComponent, h } from "vue";
import { getTagDisplaySegments } from "./service";

export default defineComponent({
  name: "TagDisplayText",
  props: {
    text: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    return () =>
      h(
        "span",
        { class: "tag-display-text" },
        getTagDisplaySegments(String(props.text || "")).reduce(
          (children, segment, index) => {
            if (index > 0) {
              children.push(h("wbr"));
            }
            children.push(segment);
            return children;
          },
          []
        )
      );
  },
});
